import logo from './logo.svg';
import './App.css';
import {createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import RootLayout from "./pages/RootLayout";
import "../src/assets/css/style.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import Login from "./pages/Login";
import Register from "./pages/Register";
import "react-toastify/dist/ReactToastify.css";
import Chats from "./pages/chats";
import {useEffect, useState} from "react";
import LoginEn from "./pages/LoginEn";
import RegisterEn from "./pages/RegisterEn";
import ChatsEn from "./pages/chatsEn";
function App() {

  const [token, setToken] = useState(null);

  useEffect(() => {
    setToken(localStorage.getItem('token'));
  }, []);

  const Router = createBrowserRouter([
    { path: '/', element:token == null ? <Login /> : <Navigate to={'/chat'} />},
    { path: '/en', element:token == null ? <LoginEn /> : <Navigate to={'/chat/en'} />},
    { path: '/register', element:token == null ? <Register /> : <Navigate to={'/chat'} /> },
    { path: '/register/en', element:token == null ? <RegisterEn /> : <Navigate to={'/chat/en'} /> },
    { path: '/chat', element:token == null ? <Navigate to={'/'} /> : <Chats /> },
    { path: '/chat/en', element:token == null ? <Navigate to={'/en'} /> : <ChatsEn /> },
  ]);

    return <RouterProvider router={Router} />;

}

export default App;
